import React, {useEffect, useState} from 'react';
import {Button, Checkbox, Col, Flex, Form, Input, Row} from "antd";
import {StyledPopUp} from "../../../../shared";
import {GuaranteePopupProps} from "../../models";
import {useForm} from "antd/es/form/Form";
import {StyledCard} from "./GuaranteePopup.styled";
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {getProductAssurance} from "../../actions/AdInsert.action";
import {useLocation} from "react-router-dom";
import TextArea from "antd/es/input/TextArea";

const GuaranteePopup = ({open, onCansel,getProductAssurance,onConfirm}: GuaranteePopupProps) => {
    const [form] = useForm();
    const [assuranceData, setAssuranceTypeData] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false);
    const location =useLocation()
    const getList = () => {
            getProductAssurance(location.state.stepOneForm.subCategoryId)
            .then((data: any) => {
                if (data.payload != undefined) {
                   let tempData = data.payload.data.map((item:any,index:any) => ({
                       name : item.name,
                       isChecked: location.state?.stepTwoForm?.productAssurances?.find((i:any) => i?.productAssuranceTypeId === item.id) || false,
                       description: location.state?.stepTwoForm?.productAssurances?.find((i:any) => i?.productAssuranceTypeId === item.id)?.description || "",
                       productAssuranceTypeId : item.id
                   }))
                    console.log(tempData)
                    form.setFieldsValue({assurance: tempData})
                    setAssuranceTypeData(tempData);

                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        getList();
    }, []);
    const onFinish = (value: any) => {
        onConfirm(value.assurance.filter((item:any) =>  item.isChecked))
        onCansel()
    }

    return (
        <StyledPopUp
            open={open}
            onCancel={onCansel}
            title={
            <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "18px", fontWeight: 600 }}>انتخاب تضامین</span>
                <span style={{ fontSize: "12px", color: "#818181ff", marginTop: "4px" }}>
   💡 لطفاً از بین گزینه‌های زیر هر کدام را که به عنوان تضمین برای آگهی خود می‌پذیرید، انتخاب کنید.
شما می‌توانید برای هر گزینه توضیح کوتاهی هم اضافه کنید.
توجه: هر گزینه‌ای که تیک نخورده باشد، به عنوان تضمین برای این آگهی درنظر گرفته نخواهد شد.                 
</span>
            </div>
            }

            width={"100%"}
            footer={null}
            transitionName={''}

        >
            <Flex vertical gap={"small"}>
                    <Form layout={"vertical"} form={form} onFinish={onFinish} >


                            <Flex vertical style={{maxHeight:"400px" , overflowY:"auto"}} >
                                <Col xs={23} sm={23} md={23} lg={23} xl={23}>

                                <Form.List name="assurance">
                                    {(fields, { add, remove }) => (
                                        <>
                                {fields.map(({ key, name, ...restField }) => (
                                    <StyledCard>
                                    <Flex vertical  style={{marginBottom:"15px"}}>
                                        <Form.Item  {...restField}
                                                    name={[key, 'isChecked']}
                                                    valuePropName={"checked"}
                                                    label={null}>

                                            <Checkbox onChange={(e) => {
                                                // Update the corresponding form value dynamically
                                                const updatedData = [...assuranceData];
                                                updatedData[key].isChecked = e.target.checked;
                                                setAssuranceTypeData(updatedData);
                                                form.setFieldsValue({ assurance: updatedData });
                                            }}>{assuranceData[key].name}</Checkbox>
                                        </Form.Item>
                                        {assuranceData[key]?.isChecked && <Form.Item  {...restField}
                                                                                      name={[key, 'description']}
                                        >

                                            <TextArea  placeholder={'توضیحات'}/>
                                        </Form.Item> }

                                    </Flex>
                                    </StyledCard>

                                ))}
                                        </>)}
                                </Form.List>

                                </Col>
                            </Flex>


                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Row justify={"center"}>
                                    <Button size={"large"} type="primary" block htmlType={"submit"}
                                           >انتخاب کنید</Button>
                            </Row>
                        </Col>

                    </Form>
            </Flex>
        </StyledPopUp>
    );
};

export default connect(null, {getProductAssurance})(withRouter(GuaranteePopup));
